import { z } from 'zod';

export const GetUsedSidListSchema = z.object({
  response: z.array(z.number())
});

export type GetUsedSidListResponse = z.infer<typeof GetUsedSidListSchema>;

type PaymentServicesFilterItem = {
  value: string;
};

export type GetHistoryParams = {
  amount: string;
  endDate: string;
  page: number;
  startDate: string;
  status: string;
  wallet: string;
  paymentServicesFilter?: PaymentServicesFilterItem[];
  move?: number;
};

export type GetHistoryRequestBody = {
  move: number;
  page: number;
  amount: string;
  status: string;
  dt_start: string;
  dt_end: string;
  wallet_hash: string;
  service_id: string | string[];
};

const HistoryItemSchema = z.object({
  id: z.number(),
  payment_instrument_id: z.number(),
  payment_instrument_name: z.string(),
  amount: z.string(),
  user_id: z.number(),
  wallet_id: z.string(),
  wallet_account_id: z.string(),
  dt: z.string(),
  move: z.number(),
  dt_done: z.string().nullable(),
  cashdesk: z.number(),
  comment: z.string(),
  status: z.string(),
  object_id: z.number().nullable(),
  service_id: z.number(),
  sevice_name: z.string(),
  currency: z.string(),
  data: z.string().nullable(),
  partner_id: z.number(),
  client_ip: z.string(),
  card_mask: z.string(),
  reason: z.string(),
  is_splitted_child: z.boolean().nullable(),
  details: z.string()
});

export type HistoryItem = z.infer<typeof HistoryItemSchema>;

export const GetHistorySchema = z.object({
  total: z.number(),
  page: z.number(),
  response: z.array(HistoryItemSchema)
});

export type GetHistoryResponse = z.infer<typeof GetHistorySchema>;

export type FormattedGetHistoryResponse = {
  data: HistoryItem[];
  page: number;
  totalPages: number;
};
